import { render, staticRenderFns } from "./CpE_LowStockReminder.vue?vue&type=template&id=37cc1e48"
import script from "./CpE_LowStockReminder.vue?vue&type=script&lang=js"
export * from "./CpE_LowStockReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports